module.exports = __webpack_public_path__ + "static/media/holiday_help_important.735c0275.svg";